(() => {
  if (customElements.get('stack-living-painting')) return;
  customElements.define('stack-living-painting', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.load = async () => {
        if (this.loading || this.dispose) return;
        this.loading = true;
        this.observer?.disconnect();
        try {
          const config = JSON.parse(this.querySelector('[data-painting-config]').textContent);
          // Shopify's theme editor can execute this CDN script with an about:blank
          // module base, so import an absolute URL instead of asset_url's // form.
          const assetUrl = this.dataset.module;
          const moduleUrl = assetUrl.startsWith('//') ? `https:${assetUrl}` : new URL(assetUrl, location.href).href;
          const { mountPainting } = await import(moduleUrl);
          if (!this.isConnected) return;
          this.dispose = mountPainting(this.querySelector('[data-painting-mount]'), config);
        } catch (error) { this.loading = false; console.error('The painting could not start.', error); }
      };
      const followHash = () => { if (['#gods','#science','#inside','#finale'].includes(location.hash)) this.load(); };
      this.observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) this.load(); }, { rootMargin: '2500px' });
      this.observer.observe(this);
      window.addEventListener('hashchange', followHash, { signal: this.controller.signal });
      followHash();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect(); this.dispose?.(); this.dispose = null; this.loading = false;
    }
  });
})();
